export default __webpack_public_path__ + "static/about-img1-00fe9141d15adf77157178b128ab3ba1.webp";